import React from 'react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'

const ReviewDetailsContainer = styled('div')(({ theme }) => ({
  fontSize: '.75em',
  width: '100%',
  color: theme.palette.primary.main,
  padding: '0 5rem',
  [theme.breakpoints.down('xs')]: {
    padding: '0 1rem',
  },
}))

const PaymentDetailsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '1.2em',
  '& p': {
    margin: 0,
    fontSize: '15px',
  },
})

const PaymentDetailsLabelsContainer = styled('div')({
  fontWeight: 'bold',
  textAlign: 'right',
})

const SubheaderStyles = styled('h2')(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: '5px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '1rem',
  },
}))

const PhrasesStyles = styled('p')({
  fontSize: '0.9em',
  margin: '0px',
  marginBottom: '15px',
})

const ButtonStyle = styled(Button)({
  marginTop: '1rem',
})

function ReviewDetails({ handleEditInformation, isCOF, isMX, formikProps }) {
  const { values = {} } = formikProps
  const {
    cardholderName,
    cardholderLastName,
    cardNumber,
    expirationDate,
    contactName,
    contactPhone,
    contactEmail,
    additionalEmails,
    contactLastName,
    memberEmail,
  } = values

  const stringCardNumber = `${cardNumber}`
  return (
    <ReviewDetailsContainer>
      <SubheaderStyles>CREDIT CARD INFORMATION</SubheaderStyles>
      <PaymentDetailsContainer style={{ marginBottom: '15px' }}>
        <div>
          {/* <p>CARD TYPE</p> */}
          <p>HOLDER</p>
          <p>NUMBER</p>
          <p>EXPIRATION</p>
        </div>
        <PaymentDetailsLabelsContainer>
          {/* <p>VISA</p> */}
          <p>{`${cardholderName} ${cardholderLastName}`}</p>
          <p>{`XXXX-XXXX-XXXX-${
            stringCardNumber?.substr(stringCardNumber.length - 4) ||
            stringCardNumber
          }`}</p>
          <p>{`${expirationDate?.match(/.{1,2}/g)?.[0]}/${
            expirationDate?.match(/.{1,2}/g)?.[1]
          }`}</p>
        </PaymentDetailsLabelsContainer>
      </PaymentDetailsContainer>
      <PaymentDetailsContainer>
        <div>
          <p>ADDRESS</p>
        </div>
        <PaymentDetailsLabelsContainer>
          <p>{values?.billingAddress1}</p>
          <p>{values?.billingAddress2}</p>
          <p>
            {values?.billingCity}, {values?.billingState}
          </p>
          <p>
            {values?.billingZipCode}, {values?.billingCountry}
          </p>
        </PaymentDetailsLabelsContainer>
      </PaymentDetailsContainer>
      <SubheaderStyles>CONTACT INFORMATION</SubheaderStyles>
      <PhrasesStyles>
        {`Once approved, ${
          isCOF
            ? 'the Cuban Overflight Permit Number'
            : isMX
            ? 'the MX Airspace Fees receipt'
            : 'the BOE letter'
        } will be sent to`}
      </PhrasesStyles>
      <PaymentDetailsContainer>
        <div>
          {/* <p>CARD TYPE</p> */}
          <p>NAME</p>
          <p>PHONE</p>
          <p>EMAIL</p>
          {additionalEmails && <p>ADDITIONAL EMAILS </p>}
          {memberEmail ? (
            memberEmail.includes('@') ? (
              <p>MEMBER</p>
            ) : (
              <p>USERNAME</p>
            )
          ) : (
            <p></p>
          )}
        </div>
        <PaymentDetailsLabelsContainer>
          <p>
            {contactName} {contactLastName}
          </p>
          <p>{contactPhone}</p>
          <p>{contactEmail}</p>
          {additionalEmails && <p>{additionalEmails}</p>}
          {memberEmail && <p>{memberEmail}</p>}
        </PaymentDetailsLabelsContainer>
      </PaymentDetailsContainer>
      {handleEditInformation && (
        <ButtonStyle
          variant="outlined"
          color="secondary"
          onClick={handleEditInformation}
          fullWidth
        >
          EDIT INFORMATION
        </ButtonStyle>
      )}
    </ReviewDetailsContainer>
  )
}

export default ReviewDetails
